



































































































































































import { InstallmentModel, InteractionModel, VForm } from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import { ActionsInstallmentStatus, InstallmentStatus } from '../../enums';

@Component
export default class DialogReactiveContractComponent extends Vue {
  @Ref() private form!: VForm;
  @Prop() readonly status!: string;

  private dialog = false;
  private reason = '';
  private valueTab = '';
  private generateCharge = true;
  private installmentOptions: {
    Id: string;
    Status: InstallmentStatus | undefined;
  }[] = [];
  private newInstallmentList: InstallmentModel[] = [];
  private installmentList: InstallmentModel[] = [];

  private mounted() {
    this.contractCreditRecurrent;
    this.installmentList = this.refs._.clone(
      this.refs.modules.contract.installmentList
    );
    this.getInstallments();
  }

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
  private get optionsParcel() {
    const list = this.refs.static.enumDescriptions.get(
      ActionsInstallmentStatus
    );
    return list;
  }
  private get contractCreditRecurrent() {
    const paymentMethod = this.refs.modules.contract.contract.PaymentMethod;
    const billingMode = this.refs.modules.contract.contract.BillingMode;
    return (
      paymentMethod?.toString() == 'Credit' &&
      billingMode?.toString() == 'Recurrent'
    );
  }
  public descriptionInstallmentStatus(installmentStatus: InstallmentStatus) {
    return this.refs.static.enumDescriptions.get2(
      InstallmentStatus,
      InstallmentStatus[installmentStatus]
    );
  }

  private reactivateContract() {
    if (this.form && this.form.validate())
      if (this.refs.modules.data.isBilling) {
        this.installmentOptions.forEach((x) => {
          const installment = this.installmentList.find((i) => i.Id == x.Id);
          (installment || { Status: InstallmentStatus }).Status = (
            this.optionsParcel.find(
              (o) => o.key == this.refs.enums.InstallmentStatus[x.Status || 0]
            ) || { key: 0 }
          ).key as InstallmentStatus;
        });

        this.installmentList.forEach((x) => {
          if (!x.Reference) {
            x.Reference = { Month: x.MonthReference, Year: x.YearReference };
          }
        });

        this.installmentList.map((x) =>
          x.PaymentInfos?.map(
            (p) => (p.DocumentType = p.DocumentType.toUpperCase())
          )
        );

        this.refs.modules.contract
          .reactivateContract({
            contractId: this.refs.modules.contract.contract.Id,
            descReason: this.reason + ' - ' + this.valueTab,
            generateCharge: this.generateCharge,
            installments: this.installmentList,
          })
          .then(async () => {
            this.$toast(this.$t('toasts.contract_reactive_successfully'));

            localStorage.removeItem('tabulacao');
            this.$bus.$emit('cleanValueTab');

            await this.refs.modules.contract.loadContractById(
              this.refs.modules.contract.contract.Id
            );
            await this.refs.modules.contract.loadInstallmentList(
              this.refs.modules.contract.contract.Id
            );
            this.dialog = false;
          })
          .catch(async (err) => {
            this.$toast.error('ERROR ? ', err);
            this.$toast(this.$t('toasts.contract_reactive_error'));
            await this.refs.modules.contract.loadContractById(
              this.refs.modules.contract.contract.Id
            );
            await this.refs.modules.contract.loadInstallmentList(
              this.refs.modules.contract.contract.Id
            );
            this.installmentList = this.refs._.clone(
              this.refs.modules.contract.installmentList
            );
            this.getInstallments();
          });
      } else {
        const policy = this.refs._.clone(this.refs.modules.policy.policy);
        policy.Status = this.refs.enums.PolicyStatus.Active;
        this.refs.modules.policy
          .updatePolicy({ policyId: policy.Id, policy })
          .then(() => {
            this.$toast(this.$t('toasts.contract_reactive_successfully'));
            this.refs.modules.ticket
              .createInteraction(
                new InteractionModel(
                  this.$t('action_code.ac5'),
                  this.reason + ' - ' + this.valueTab
                )
              )
              .then(() => {
                localStorage.removeItem('tabulacao');
                this.$bus.$emit('cleanValueTab');
              });
            this.refs.modules.policy.loadPolicyById(policy.Id);
            this.dialog = false;
          })
          .catch((err) => {
            this.$toast.error('ERROR ? ', err);
            this.$toast.error(this.$t('toasts.contract_reactive_error'));
          });
      }
  }

  private getInstallments() {
    const result = this.installmentList
      .filter(
        (installment) =>
          (this.refs.enums.InstallmentStatus[installment.Status] &&
            this.refs.enums.InstallmentStatus[installment.Status].toString() ==
              this.refs.enums.InstallmentStatus.Defaulter.toString()) ||
          (this.refs.enums.InstallmentStatus[installment.Status].toString() ==
            this.refs.enums.InstallmentStatus.Canceled.toString() &&
            (this.refs.modules.contract.contract.CancelationDate ||
              new Date()) < (installment.OriginalDueDate || new Date())) ||
          this.refs.enums.InstallmentStatus[installment.Status].toString() ==
            this.refs.enums.InstallmentStatus.ChargebackRequested.toString()
      )
      .sort((a, b) => ((a.Number || '') < (b.Number || '') ? -1 : 1));

    const installmentFinal = this.refs._.maxBy(this.installmentList, 'Number');

    const dateMin = new Date(
      installmentFinal?.Reference?.Year || installmentFinal?.YearReference || 0,
      (installmentFinal?.Reference?.Month ||
        installmentFinal?.MonthReference ||
        0) - 1,
      1
    );
    const dateMax = new Date(Date.now());

    const qntParcels = this.monthDiff(dateMin, dateMax);

    if (
      this.refs.modules.contract.contract.BillingMode?.toString() == 'Recurrent'
    ) {
      for (let i = 1; i <= qntParcels; i++) {
        this.addNewInstallment();
      }
    }

    result.push(...this.newInstallmentList);

    this.installmentOptions = this.refs._.clone(
      result.map((x) => ({
        Id: x.Id,
        Status: undefined,
      }))
    );

    this.installmentList = this.refs._.clone(result);
  }

  private async addNewInstallment() {
    const { Value } = this.refs.modules.contract.contract;
    let installmentLast = {} as InstallmentModel | undefined;
    if (this.newInstallmentList && this.newInstallmentList.length > 0) {
      installmentLast = this.refs._.maxBy(this.newInstallmentList, 'Number');
    } else {
      installmentLast = this.refs._.maxBy(this.installmentList, 'Number');
    }
    if (installmentLast)
      this.newInstallmentList.push({
        Id: this.refs.util.generateGuid(),
        Status: this.refs.enums.InstallmentStatus.Generated,
        OriginalDueDate:
          this.newInstallmentList.length > 0
            ? this.refs
                .moment(installmentLast.OriginalDueDate, 'YYYY-MM-DD')
                .add(1, 'day')
                .format('YYYY-MM-DD')
            : this.refs
                .moment()
                .add(1, 'day')
                .format('YYYY-MM-DD'),
        Reference: {
          Year:
            (installmentLast.Reference?.Month ||
              installmentLast.MonthReference ||
              0) < 12
              ? installmentLast.Reference?.Year || installmentLast.YearReference
              : (installmentLast.Reference?.Year ||
                  installmentLast.YearReference ||
                  0) + 1,
          Month:
            (installmentLast.Reference?.Month ||
              installmentLast.MonthReference ||
              0) < 12
              ? (installmentLast.Reference?.Month ||
                  installmentLast.MonthReference ||
                  0) + 1
              : 1,
        },
        Value: Value,
        Number: installmentLast?.Number ? installmentLast.Number + 1 : 0,
        InstallmentType: this.refs.enums.InstallmentType.Ordinary,
      });
  }

  private monthDiff(d1: Date, d2: Date) {
    let months;
    months = (new Date(d2).getFullYear() - new Date(d1).getFullYear()) * 12;
    months -= new Date(d1).getMonth();
    months += new Date(d2).getMonth();
    return months <= 0 ? 0 : months;
  }

  @Watch('dialog')
  private onChangeDialog(value: boolean): void {
    this.valueTab = localStorage.getItem('tabulacao') ?? '';
    if (value && this.form) this.form.resetValidation();
  }
}
